/**
 * MessageBubble - Single chat message bubble
 */

import React from 'react';
import { motion } from 'framer-motion';
import { isImageAvatarUrl } from '../../lib/avatars';

export default function MessageBubble({ message, isOwn, avatar, senderName }) {
  const time = new Date(message.createdAt || message.created_at).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className={`flex gap-2 mb-3 ${isOwn ? 'flex-row-reverse' : 'flex-row'}`}
    >
      {/* Avatar */}
      {!isOwn && (
        <div className="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center text-lg flex-shrink-0 overflow-hidden">
          {isImageAvatarUrl(avatar) ? (
            <img src={avatar} alt={senderName} className="w-full h-full object-cover" />
          ) : (
            <span>{avatar || '👤'}</span>
          )}
        </div>
      )}

      {/* Bubble */}
      <div className={`flex flex-col ${isOwn ? 'items-end' : 'items-start'} max-w-[80%]`}>
        <div
          className={`rounded-2xl px-3 py-2 shadow-sm ${
            isOwn
              ? 'bg-white/20 backdrop-blur-sm border border-white/20 text-right'
              : 'bg-black/20 backdrop-blur-sm border border-white/10 text-left'
          }`}
        >
          <div className={`text-[11px] ${isOwn ? 'text-white/80' : 'text-white/90'} mb-0.5`}>{senderName}</div>
          <p className="text-sm text-white whitespace-pre-wrap break-words">
            {message.body || message.content}
          </p>
        </div>
        <span className="text-xs text-white/40 mt-1 px-1">
          {time}
          {message.failed && (
            <span className="ml-2 text-red-400" title={message.error || 'Failed to send'}>
              Failed to send
            </span>
          )}
        </span>
      </div>
    </motion.div>
  );
}
